import { useTranslation } from '@mc/i18n'
import {
  CertificateSignupChecklist,
  CertificateSignupCTA,
} from 'pages/certificates/components/MarketingCertPage'

export const TrailerPauseScreen = ({
  subtext,
  showCTA = true,
}: {
  subtext?: string
  showCTA?: boolean
}) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <div
      className='position-absolute d-flex flex-column justify-content-center align-items-center c-text-color--light'
      style={{ inset: 0, background: 'rgba(var(--c-beige-1400-rgb), 0.9)' }}
    >
      <div style={{ maxWidth: '450px' }}>
        <h2
          className='c-d-1 c-text-ivar-display-condensed c-mb-6'
          style={{ maxWidth: '18ch' }}
        >
          {t('marketingPages.certificate.certificateSection.title')}
        </h2>
        <CertificateSignupChecklist />
        {showCTA && (
          <div className='c-mt-6'>
            <CertificateSignupCTA subtext={subtext} />
          </div>
        )}
      </div>
    </div>
  )
}
